import { render } from "./BuildingEdit.vue?vue&type=template&id=13018981&scoped=true"
import script from "./BuildingEdit.vue?vue&type=script&lang=js"
export * from "./BuildingEdit.vue?vue&type=script&lang=js"

import "./BuildingEdit.vue?vue&type=style&index=0&id=13018981&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13018981"]])

export default __exports__